import { VIRTUAL_ROOM_COUNT } from '../config/virtualRooms';

export function getEventStartTime(ev) {
  const [hh, mm = 0] = (ev.time || '00:00').split(':').map((x) => parseInt(x, 10) || 0);
  const d = new Date();
  if (ev.eventDate && /^\d{4}-\d{2}-\d{2}$/.test(ev.eventDate)) {
    const [y, m, day] = ev.eventDate.split('-').map((x) => parseInt(x, 10));
    d.setFullYear(y, m - 1, day);
  }
  d.setHours(hh, mm, 0, 0);
  return d;
}

export function getEventEndTime(ev) {
  const start = getEventStartTime(ev);
  const durationMinutes = ev.minutes != null ? Math.max(ev.minutes, 60) : 60;
  return new Date(start.getTime() + durationMinutes * 60 * 1000);
}

/** Live events per room (join window ends 10 min before event end). */
export function getNowLiveEventsByRoom(events) {
  const now = Date.now();
  const byRoom = {};
  for (let r = 1; r <= VIRTUAL_ROOM_COUNT; r++) {
    byRoom[r] = null;
  }
  for (const ev of events) {
    const room = ev.roomNumber ?? ev.room_number ?? 1;
    const start = getEventStartTime(ev).getTime();
    const end = getEventEndTime(ev).getTime();
    const joinCutoff = end - 10 * 60 * 1000;
    if (now >= start && now < joinCutoff && !byRoom[room]) {
      byRoom[room] = ev;
    }
  }
  return byRoom;
}

const SOON_MS = 15 * 60 * 1000;

/** Events starting within 15 minutes, per room (not yet live). */
export function getStartingSoonEventsByRoom(events) {
  const now = Date.now();
  const byRoom = {};
  for (let r = 1; r <= VIRTUAL_ROOM_COUNT; r++) {
    byRoom[r] = null;
  }
  for (const ev of events) {
    const room = ev.roomNumber ?? ev.room_number ?? 1;
    const start = getEventStartTime(ev).getTime();
    if (now < start && start - now <= SOON_MS && !byRoom[room]) {
      byRoom[room] = ev;
    }
  }
  return byRoom;
}

export function matchesEventTypeFilter(ev, filter) {
  if (!filter || filter === 'all') return true;
  const et = ev.eventType || ev.event_type || '';
  if (filter === 'game') return et === 'game';
  if (filter === 'chat') return et === 'keskustelu' || et === 'stream';
  if (filter === 'movie') return et === 'movie';
  if (filter === 'livestream:music') return et === 'livestream' && ev.livestreamType === 'music';
  if (filter === 'livestream:talk') return et === 'livestream' && ev.livestreamType === 'talk';
  return true;
}

export function matchesLivestreamCategoryFilter(ev, categoryFilter) {
  if (!categoryFilter || categoryFilter === 'all') return true;
  if (ev.eventType !== 'livestream') return true;
  return (ev.livestreamCategory || '') === categoryFilter;
}
